module.exports = __webpack_public_path__ + "static/media/11.0164c426.jpg";